var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{domProps:{"innerHTML":_vm._s(_vm.$sanitize(_vm.value.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, `$1${_vm.nl2br}$2`), { disallowedTagsMode: 'escape' }))}})
}
var staticRenderFns = []

export { render, staticRenderFns }